import { render } from "./ByCategory.vue?vue&type=template&id=f9bb516c"
import script from "./ByCategory.vue?vue&type=script&lang=js"
export * from "./ByCategory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__